<app-header (loadListings)="loadListings()"></app-header>
<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<div class="wrapper">
    <div class="section_wrapper">
        <p *ngIf="isNoListingsAvailable"
            style="background-color: #115664; color:white; padding: 20px; margin-top:10px;font-size:18px">You have not
            listed a home for sale yet. <br><br>Click the 'Sell My Home' button to start listing now.</p>
        <h3 class="font_36_500 card_heading" *ngIf="activeListing.length > 0">Active Listings</h3>
        <h3 class="font_36_500 card_heading" style="margin-top: 28px;" *ngIf="inProgressListing.length > 0">In Progress
            Listings</h3>
        <div class="my_listing_wrap" *ngIf="inProgressListing.length > 0">
            <div *ngFor="let list of inProgressListing; let i = index" class="users_listing">
                <div class="images_wrap">
                    <div class="image_buttons">
                        <div class="new_button overlayText" *ngIf="list.stripePaymentStatus != 'paid'">
                            {{list.stageName.split(',')[0]}}</div>
                        <div class="overlayText" *ngIf="list.stripePaymentStatus == 'paid'">
                            {{list.listingCheckoutStatus ? list.listingCheckoutStatus : "Payment Success" }}
                        </div>

                        <button [matMenuTriggerFor]="menu" class="three_dot">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button *ngIf="list.stripePaymentStatus != 'paid'" mat-menu-item
                                (click)="showDialog(list,i)">
                                Delete
                            </button>


                            <button mat-menu-item *ngIf="list.stripePaymentStatus == 'paid'"
                                (click)="refresh(list,i,'inprogress')">
                                Refresh
                            </button>

                        </mat-menu>

                        <!-- showing delete dialog -->
                        <app-delete-dialog *ngIf="showDeleteDialog" title="Delete this property?"
                            subTitle="Changes you made so far will not be saved.">
                            <div class="dialog_action">
                                <button class="dialog_Cancel_btn" (click)="showDialog(null,0)">Cancel</button>
                                <app-green-button-v2 [width]="'134px'" (click)="deleteListing()" height="56px"
                                    [label]="'Delete'"></app-green-button-v2>
                            </div>
                        </app-delete-dialog>
                        <!-- dialog ends -->
                    </div>


                    <img *ngIf="list.imgUrl" src="{{list.imgUrl}}" alt="">
                    <img *ngIf="!list.imgUrl && list.ImageIds && list.ImageIds.length > 0"
                        src="{{media_base_url + list.ImageIds[0]}}" alt="">
                    <img *ngIf="!list.imgUrl && (!list.ImageIds || list.ImageIds.length == 0)"
                        src="../../../assets/images/no_image_availble.png">

                </div>
                <div class="detail_card">
                    <div class="d_flex justify_space_bt align_center">
                        <p class="worth" *ngIf="list.ListPrice">${{list.ListPrice | number}}</p>
                        <app-green-button-v2 class="card_body_button" [styles]="{fontSize:'14px'}" label="Manage"
                            width="80px" height="30px" *ngIf="!list.isCardLoader "
                            (click)="continue(list)"></app-green-button-v2>
                        <app-loader class="loader_wrap card_body_button" *ngIf="list.isCardLoader"></app-loader>

                    </div>
                    <p class="address font_16_a32_500">{{list.fullAddress}}</p>
                    <div class="property_detail">
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Beds</span>
                            <br>{{list.BedroomsTotal | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Baths</span>
                            <br>{{list.BathroomsFull | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">SqFt</span>
                            <br>{{list.LivingArea | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Sq Ft Lot </span>
                            <br>{{list.LotSizeSqFt | number}}
                        </p>
                    </div>
                    <p class="photo-pending"
                        *ngIf="(list.stripePaymentStatus == 'paid' || hidePlanSelection) && (!list.ImageIds || list?.ImageIds.length == 0)">
                        Photo Upload Pending</p>
                </div>

            </div>
        </div>
        <div *ngIf="!isNoListingsAvailable && !atLeastPaidOneListing"
            style="background-color: #115664; color:white; padding: 20px; margin-top:10px">
            <p class="font_18_a32_300"
                style="font-size: 18px;line-height: 30px; margin: 40px;padding:40px; background-color: #f0f0f0; color:black"
                *ngIf="haveUnpaidListings && !hidePlanSelection"><span style="font-weight:bold;">Note:</span>
                You have an incomplete listing that you can complete by clicking on the "Continue" button next to it</p>
        </div>
        <div *ngIf="!isNoListingsAvailable && atLeastPaidOneListing"
            style="background-color: #115664; color:white; padding: 20px; margin-top:10px">
            <h3 style="color:white;font-size:22px">Next Steps: Launching Your Home Selling Journey with HomeRise</h3>
            <p class="font_18_a32_300" style="font-size: 18px;line-height: 30px;padding-left:30px">Congratulations on
                taking a significant step towards a smarter home-selling experience with HomeRise!
                <br>
                Like thousands before you, you're on the path to saving thousands on your home sale.
            </p>

            <p class="font_18_a32_300"
                style="font-size: 18px;line-height: 30px; margin: 40px;padding:40px; background-color: #f0f0f0; color:black"
                *ngIf="haveUnpaidListings && !hidePlanSelection"><span style="font-weight:bold;">Note:</span>
                You have an incomplete listing that you can complete by clicking on the "Continue" button next to it</p>

            <p style="color:white;font-size:20px;padding-bottom:15px;padding-top:20px;font-weight: bold;">What Happens
                Now?</p>
            <p class="font_18_a32_300" style="font-size: 18px;line-height: 30px;padding-left:30px;"><span
                    style="font-weight: bold;">Schedule Your Launch Call</span>:
                A member of our client care team will be reaching out to schedule your launch call. <br>
                If you prefer, you can book your call immediately
                <a href="https://meetings.hubspot.com/david-speers/homerise-launch"><button
                        style="font-size:14px;font-weight:bold; border-radius: 10px; border-color: white;">Schedule My
                        Launch Call</button></a>
                <br>During your launch call, you’ll speak with a Listing Specialist.
                This expert will provide tailored advice and insights for your home, ensuring you're perfectly
                positioned in the market.
            </p>
            <br>
            <p style="color:white;font-size:18px">Your journey with HomeRise is just beginning; we're thrilled to be
                part of it.
                Together, let's turn your home-selling goals into reality.
            </p>
        </div>
        <div class="my_listing_wrap" *ngIf="activeListing.length > 0">
            <div *ngFor="let list of activeListing; let i = index" class="users_listing">
                <div class="images_wrap">
                    <div class="image_buttons">

                        <div class="overlayText" *ngIf="list.listingCheckoutStatus">
                            {{list.listingCheckoutStatus}}
                        </div>
                        <button [matMenuTriggerFor]="menu" class="three_dot">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">


                            <button mat-menu-item
                                *ngIf="list.stripePaymentStatus == 'paid' && list.listingCheckoutOrderId != null"
                                (click)="refresh(list,i,'active')">
                                Refresh
                            </button>
                        </mat-menu>
                    </div>

                    <img *ngIf="list.imgUrl" src="{{list.imgUrl}}" alt="">
                    <img *ngIf="!list.imgUrl && list.ImageIds && list.ImageIds.length > 0"
                        src="{{media_base_url + list.ImageIds[0]}}" alt="">
                    <img *ngIf="!list.imgUrl && (!list.ImageIds || list.ImageIds.length == 0)"
                        src="../../../assets/images/no_image_availble.png">

                </div>
                <div class="detail_card">
                    <div class="d_flex justify_space_bt align_center">
                        <p class="worth">${{list.ListPrice | number}}</p>
                        <app-green-button-v2 class="card_body_button" [styles]="{fontSize:'14px'}" label="Manage"
                            width="73px" height="30px"
                            *ngIf="!list.isCardLoader  && list.listingCheckoutOrderId != null"
                            (click)="manage(list,false)"></app-green-button-v2>
                        <app-loader class="loader_wrap" *ngIf="list.isCardLoader"></app-loader>

                    </div>
                    <p class="address font_16_a32_500">{{list.fullAddress}}</p>
                    <div class="property_detail">
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Beds</span>
                            <br>{{list.BedroomsTotal | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Baths</span>
                            <br>{{list.BathroomsFull | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">SqFt</span>
                            <br>{{list.LivingArea | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Sq Ft Lot </span>
                            <br>{{list.LotSizeSqFt | number}}
                        </p>
                    </div>
                </div>

            </div>
        </div>


        <h3 class="font_36_500 card_heading" *ngIf="pastListing.length > 0">Past Listings</h3>
        <div class="my_listing_wrap" *ngIf="pastListing.length > 0">
            <div *ngFor="let list of pastListing; let i = index" class="users_listing">
                <div class="images_wrap">
                    <div class="image_buttons">

                        <div class="overlayText" *ngIf="list.listingCheckoutStatus">
                            {{list.listingCheckoutStatus}}
                        </div>

                    </div>


                    <img *ngIf="list.imgUrl" src="{{list.imgUrl}}" alt="">
                    <img *ngIf="!list.imgUrl && list.ImageIds && list.ImageIds.length > 0"
                        src="{{media_base_url + list.ImageIds[0]}}" alt="">
                    <img *ngIf="!list.imgUrl && (!list.ImageIds || list.ImageIds.length == 0)"
                        src="../../../assets/images/no_image_availble.png">

                </div>
                <div class="detail_card">
                    <div class="d_flex justify_space_bt align_center">
                        <p class="worth">${{list.ListPrice | number}}</p>

                    </div>
                    <p class="address font_16_a32_500">{{list.fullAddress}}</p>
                    <div class="property_detail">
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Beds</span>
                            <br>{{list.BedroomsTotal | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Baths</span>
                            <br>{{list.BathroomsFull | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">SqFt</span>
                            <br>{{list.LivingArea | number}}
                        </p>
                        <p class="font_18_a32_700"> <span class="font_16_211d_500">Sq Ft Lot </span>
                            <br>{{list.LotSizeSqFt | number}}
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>